import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";
import profilesListData from "layouts/profile/data/profilesListData";
import team3 from "assets/images/team-3.jpg";
import BillingInformation from "layouts/billing/components/BillingInformation";
import GeneralDetails from "layouts/billing/components/GeneralDetails";
import Transactions from "layouts/billing/components/Transactions";
import OfficialDetails from "layouts/billing/components/OfficialDetails";
import Dependents from "layouts/billing/components/Dependents";
import {useEffect, useState} from "react";
import {GET, BASE_URL} from "../../APIclient";
import {useLocation, useNavigate} from "react-router-dom";
import Bill_address from "layouts/billing/components/Bill_address";
import Bill_dependents from "layouts/billing/components/Bill_dependents";
import Bill_Passport from "layouts/billing/components/Bill_Passport";
import Bill_Bank from "layouts/billing/components/Bill_Bank";
import Bill_Driving from "layouts/billing/components/Bill_Driving";
import Bill_Aadhar from "layouts/billing/components/Bill_Aadhar";
import Bill_Experience from "layouts/billing/components/Bill_Experience";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import {LinearProgress} from "@mui/material";
import {formatDesignation} from "constants/ApplicationConstants";

function Overview() {
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  let navigate = useNavigate();
  const [empId, setEmpId] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      let url = "";
      if (usersState) {
        setEmpId(usersState);
        url = `employee/employee-details/${usersState}`;
      } else if (window.sessionStorage.getItem("empId")) {
        url = `employee/employee-details/${window.sessionStorage.getItem("empId")}`;
      }

      try {
        const response = await GET(url);
        const data = response.data?.data || response;
        if (response.data && response.data.statusCode === 200) {
          setUserData(data);
        } else if (response.data && response.data.statusCode === 403) {
          console.log(response.message);
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error adding data:", error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    };

    fetchData();

    return () => {};
  }, [usersState]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            height: "80vh",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress color="info" />
        </Box>
      ) : (
        <>
          <Header userData={userData ? userData?.employee : {}}>
            {isLoading && <LinearProgress color="info" />}
            {!isLoading && (
              <>
                <MDBox mt={3} mb={3}>
                  <MDBox mb={6}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={12}>
                        <OfficialDetails details={userData ? userData?.employee : {}} />
                        <GeneralDetails details={userData ? userData?.employee : {}} />
                        <Bill_address details={userData ? userData?.employee : {}} />
                        <Bill_dependents dependents={userData ? userData?.dependents : {}} />
                        <Bill_Passport details={userData ? userData?.employee : {}} />
                        <Bill_Bank details={userData ? userData?.employee : {}} />
                        <Bill_Driving details={userData ? userData?.employee : {}} />
                        <Bill_Aadhar details={userData ? userData?.employee : {}} />
                        <Bill_Experience experiences={userData ? userData?.experiences : {}} />
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </>
            )}
          </Header>
        </>
      )}
    </DashboardLayout>
  );
}

export default Overview;
